import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useSendFullStoryEvent, useTrackEvent } from "@zapier/toolbox-tracking";
import { upgradeReasons } from "@zapier/upsells/esm/types";
import { EmailSupportUpgradeNudge, MultistepUpgradeNudge, PathsUpgradeNudge, PremiumAppLimitUpgradeNudge, PremiumAppUpgradeNudge, TaskLimitLowUpgradeNudge, TaskLimitUpgradeNudge, ZapLimitUpgradeNudge, } from "./nudges";
export const NudgeModalView = ({ appName, canExtendTrial, destinationPlan, onClose, onExtendTrialClick, onUpgradeClick, upgradeReason, wasTriggeredByZapToggle, }) => {
    const eventProperties = {
        upgradeReason,
    };
    useSendFullStoryEvent("Viewed Upgrade Modal", eventProperties);
    useTrackEvent("revenue: viewed-upgrade-modal", eventProperties);
    switch (upgradeReason) {
        case upgradeReasons.emailSupport:
            return (_jsx(EmailSupportUpgradeNudge, { onClose: onClose, onUpgradeClick: onUpgradeClick }));
        case upgradeReasons.multistep:
            return (_jsx(MultistepUpgradeNudge, { canExtendTrial: canExtendTrial, onClose: onClose, onExtendTrialClick: onExtendTrialClick, onUpgradeClick: onUpgradeClick }));
        case upgradeReasons.paths:
            return (_jsx(PathsUpgradeNudge, { canExtendTrial: canExtendTrial, onClose: onClose, onExtendTrialClick: onExtendTrialClick, onUpgradeClick: onUpgradeClick, wasTriggeredByZapToggle: wasTriggeredByZapToggle }));
        case upgradeReasons.premium:
            return (_jsx(PremiumAppUpgradeNudge, { appName: appName, canExtendTrial: canExtendTrial, onClose: onClose, onExtendTrialClick: onExtendTrialClick, onUpgradeClick: onUpgradeClick }));
        case upgradeReasons.premiumLimit:
            return (_jsx(PremiumAppLimitUpgradeNudge, { appName: appName, canExtendTrial: canExtendTrial, onClose: onClose, onExtendTrialClick: onExtendTrialClick, onUpgradeClick: onUpgradeClick }));
        case upgradeReasons.taskLimit:
            return _jsx(TaskLimitUpgradeNudge, { onClose: onClose });
        case upgradeReasons.taskLimitLow:
            return _jsx(TaskLimitLowUpgradeNudge, { onClose: onClose });
        case upgradeReasons.zapLimit:
            return (_jsx(ZapLimitUpgradeNudge, { canExtendTrial: canExtendTrial, destinationPlan: destinationPlan, onClose: onClose, onExtendTrialClick: onExtendTrialClick, onUpgradeClick: onUpgradeClick }));
        default:
            console.error(`Inline upgrade: invalid upgrade reason \`${upgradeReason}\``);
            return null;
    }
};

// @zapier/upsells@8.0.1 (466b4077f)
